// extracted by mini-css-extract-plugin
module.exports = {"quickAction":"quickAction-module--quickAction--1Zx8D","description":"quickAction-module--description--1uVfZ"};